export const valueScoreMetricTag = 'value:';
export const riskScoreMetricTag = 'risk:';
export const investmentScoreMetricTag = 'investment:';
export const totalScoreTag = 'score:';
